// hud-format.ts — the pure read-model + shared constants for the in-game HUD BOTTOM
// BAR (HTML/DOM UI shell plan, Phase 5, Form 5). The DOM HUD renders the SAME numbers
// the canvas InputUIForm displays (inputui.ts CreditsControl / PowerControl). The
// readouts are now drawn through the REAL kifntHud bitmap font (hud-readout.ts
// reproduces CreditsControl.OnPaint / PowerControl.OnPaint), so this module holds only
// the per-frame state shape + the geometry constants the renderer shares — no DOM, no
// sim, node-testable.

/** game/InputUI.cpp:564 — the credit count is clamped at 99999 for display. */
export const kCreditsDisplayMax = 99999;
/** game/InputUI.cpp:607,694 — the power meter is 10 pips (divides evenly by 10). */
export const kPowerMeterPips = 10;

/** The four per-frame HUD values, read from the SAME getters the canvas uses
 *  (plrLocal.GetCredits / GetNeedCreditsCount / GetPowerDemand / GetPowerSupply,
 *  inputui.ts:274-277). DISPLAY-only — no commands. */
export interface HudState {
  /** plrLocal.GetCredits(). */
  credits: number;
  /** plrLocal.GetNeedCreditsCount() — structures starved for credits; > 0 ⇒ low. */
  needCredits: number;
  /** plrLocal.GetPowerDemand(). */
  powerDemand: number;
  /** plrLocal.GetPowerSupply(). */
  powerSupply: number;
  /** PowerControl.m_nDemandMax — the max nPowerDemand across structure types
   *  (inputui.ts:638-651). The meter dips into the YELLOW "warning" zone when
   *  supply-demand <= demandMax (one more structure could overload, inputui.ts:684).
   *  Constant per level. */
  demandMax: number;
  /** the current SYMBOL-FLASH phase: true ⇒ the low symbol glyph is drawn this frame,
   *  false ⇒ it is blanked. Computed EXACTLY like the canvas (inputui.ts:582-597 /
   *  721-737): the flash phase from sim.GetUpdateCount() toggling every
   *  kcupdSymbolFlashRate (8) updates, AND'd with the kfPerfSymbolFlashing perf
   *  option. When the option is OFF the canvas keeps the symbol solid → flashOn is
   *  always true. Only meaningful while the corresponding readout is low. */
  flashOn: boolean;
  /** TS-only: attack-move is ARMED (the HUD toggle / a tap-hold) — the attack-move HUD
   *  button renders in its active state. Optional (absent ⇒ not armed). */
  attackMoveArmed?: boolean;
}
